module.exports = __webpack_public_path__ + "media/images/app/colors/colors-gold-99f3250bceecbd2cf7ee9b65e660b77d.webp";